import { useAuth } from '../../../common/hooks/useAuth';
import { useSzafir } from '../../../common/hooks/useSzafir';
import { useSpdCore } from '../../../common/hooks/useSpdCore';

import { signP1XmlWithSzafir } from './signP1XmlWithSzafir';

/** Sends a judgment to P1, signing with Szafir first if the user has opted
 * into client-side signing, otherwise signing with the server-stored
 * certificate as before. */
export async function sendJudgmentToP1(
  auth: ReturnType<typeof useAuth>,
  szafir: ReturnType<typeof useSzafir>,
  spd: ReturnType<typeof useSpdCore>,
  judgmentId: string,
): Promise<void> {
  const { id: documentId } =
    await spd.judgmentP1Documents.getLastForJudgment(judgmentId);
  await signP1Document(auth, szafir, spd, documentId);
}

/** Signs a queued P1 document (judgment or cancellation) so the pending-
 * documents job sends it: with Szafir if the user opted into client-side
 * signing, otherwise with the server-stored certificate. */
export async function signP1Document(
  auth: ReturnType<typeof useAuth>,
  szafir: ReturnType<typeof useSzafir>,
  spd: ReturnType<typeof useSpdCore>,
  documentId: string,
): Promise<void> {
  if (auth.userProfile?.signP1WithSzafir) {
    const signedXmlBase64 = await signP1XmlWithSzafir(
      szafir,
      spd,
      auth.userProfile?.pin || '',
      documentId,
    );
    await spd.judgmentP1Documents.signWithSzafir(documentId, signedXmlBase64);
  } else {
    await spd.judgmentP1Documents.sign(documentId);
  }
}
